<template>
  <div class="waitingcallNationality notranslate">
    <h1 class="boxTitle mb30 toUppercase">국적을 선택해주세요.</h1>
    <div class="btns">
      <button type="button" class="btn btnRound btnWhite" @click.stop="setNationality('domestic')">{{locale.domestic}}</button>
      <button type="button" class="btn btnRound btnWhite" @click.stop="setNationality('foreign')">FOREIGNER</button>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'ln',
    'locale',
    'isPublic'
  ],
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
    setNationality (nationality) {
      this.$router.push({
        name: 'waitingcallAuth',
        params: {
          ...this.$router.params,
          nationality: nationality
        }
      })
    }
  }
}
</script>
